// @ts-nocheck
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/auth";
import { getErrorMessage } from "../api/client";
import "../styles/Login.css";
import cardexLogo from "../assets/Cardex Login Final Logo.png";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    if (loading) return;
    setLoading(true);
    try {
      await requestPasswordReset(email.trim(), `${window.location.origin}/reset-password`);
      setSubmitted(true);
    } catch (err) {
      setError(getErrorMessage(err, "Couldn't send the reset link. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <main className="screen auth-screen forgot-screen">
        <div className="bg-glow" />
        <div className="login-grid-lines" aria-hidden="true"></div>
        <div className="login-noise" aria-hidden="true"></div>

        <div className="login-scene auth-scene forgot-scene">
          <section className="hero login-hero auth-hero">
            <img src={cardexLogo} alt="Cardex" className="logo" />
            <h1 className="title auth-title">
              Check your
              <br />
              email inbox
            </h1>
            <p className="subtitle auth-subtitle">
              We sent password reset instructions to <strong>{email}</strong>. Follow the link to securely regain access.
            </p>
          </section>

          <section className="card login-panel forgot-panel" aria-label="Reset status">
            <div className="login-panel-glow" aria-hidden="true"></div>
            <div className="login-panel-top">
              <div>
                <p className="login-panel-kicker">Reset sent</p>
                <h2 className="login-panel-title">Next step</h2>
              </div>
            </div>

            <div className="login-panel-banner">
              <div className="banner-copy">
                <strong>Watch for the email</strong>
                <span>It may take a minute to arrive. Check spam or promotions if you don’t see it.</span>
              </div>
              <div className="banner-pulse" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <div className="form">
              <p className="forgot-success-copy">
                Didn&apos;t receive the email? Check your spam folder or try again with another address.
              </p>
              <button className="btn-primary login-submit" type="button" onClick={() => setSubmitted(false)}>
                <span>Try another email</span>
              </button>
            </div>

            <footer className="footer login-footer">
              <p>
                <Link className="link strong" to="/login">Back to login</Link>
              </p>
            </footer>
          </section>
        </div>
      </main>
    );
  }

  return (
    <main className="screen auth-screen forgot-screen">
      <div className="bg-glow" />
      <div className="login-grid-lines" aria-hidden="true"></div>
      <div className="login-noise" aria-hidden="true"></div>

      <div className="login-scene auth-scene forgot-scene">
        <section className="hero login-hero auth-hero">
          <img src={cardexLogo} alt="Cardex" className="logo" />
          <h1 className="title auth-title">
            Reset your
            <br />
            password
          </h1>
          <p className="subtitle auth-subtitle">
            Enter your email address and we&apos;ll send a secure reset link so you can get back into Cardex.
          </p>
        </section>

        <section className="card login-panel forgot-panel" aria-label="Reset form">
          <div className="login-panel-glow" aria-hidden="true"></div>
          <div className="login-panel-top">
            <div>
              <p className="login-panel-kicker">Forgot password</p>
              <h2 className="login-panel-title">Recover access</h2>
            </div>
          </div>

          <div className="login-panel-banner">
            <div className="banner-copy">
              <strong>We’ll email your reset link</strong>
              <span>Use the same email tied to your Cardex account for the fastest recovery.</span>
            </div>
            <div className="banner-pulse" aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <form className="form" onSubmit={handleSubmit}>
            {error && <div className="error-msg">{error}</div>}

            <label className="label" htmlFor="email">Email Address</label>
            <div className="input-wrap">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="collector@cardex.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button className="btn-primary login-submit" type="submit" disabled={loading}>
              <span>{loading ? "Sending…" : "Send reset link"}</span>
            </button>
          </form>

          <footer className="footer login-footer">
            <p>
              <Link className="link strong" to="/login">Back to login</Link>
            </p>
          </footer>
        </section>
      </div>
    </main>
  );
}
